// Category thumbnail images from Unsplash (free license)
// Sized at 64×64 with fit=crop for ingredient thumbnails (displayed at 32px for retina crispness)

export const CATEGORY_IMAGES: Record<string, string> = {
  // Default fallback image
  Other: 'https://images.unsplash.com/photo-1751151950056-cfaf797f4653?w=64&h=64&fit=crop',

  // Food categories
  Produce: '/categories/produce.jpg',
  Bakery:
    'https://images.unsplash.com/photo-1752850743978-291651168650?w=64&h=64&fit=crop',
  Seafood:
    'https://images.unsplash.com/photo-1763062550082-2c9f94096abb?w=64&h=64&fit=crop',
  Meat: 'https://images.unsplash.com/photo-1633096013004-e2cb4023b560?w=64&h=64&fit=crop',
  'Breakfast Items':
    'https://images.unsplash.com/photo-1559332167-dd24746aa6f5?w=64&h=64&fit=crop',
  'Dry Goods':
    'https://images.unsplash.com/photo-1664337873169-5a65628ab435?w=64&h=64&fit=crop',
  'Canned Goods':
    'https://images.unsplash.com/photo-1760368104013-3a52a7f4e07b?w=64&h=64&fit=crop',
  Condiments:
    'https://images.unsplash.com/photo-1741519301128-8426ea15d03e?w=64&h=64&fit=crop',
  Spices:
    'https://images.unsplash.com/photo-1634612831148-03a8550e1d52?w=64&h=64&fit=crop',
  'Baking Supplies':
    'https://images.unsplash.com/photo-1710857389305-5cba9211033f?w=64&h=64&fit=crop',
  Snacks:
    'https://images.unsplash.com/photo-1734039037235-57a72e65d630?w=64&h=64&fit=crop',
  Beverages:
    'https://images.unsplash.com/photo-1605468488088-378c7cad2241?w=64&h=64&fit=crop',
  Dairy:
    'https://images.unsplash.com/photo-1552767059-ce182ead6c1b?w=64&h=64&fit=crop',

  // Non-food categories
  'Personal Care':
    'https://images.unsplash.com/photo-1729534657189-64cade8ef5a6?w=64&h=64&fit=crop',
  Household:
    'https://images.unsplash.com/photo-1759846866217-e627e4478f82?w=64&h=64&fit=crop',
  'Frozen Foods':
    'https://images.unsplash.com/photo-1487560227971-981afbe1c020?w=64&h=64&fit=crop',
}

export function getCategoryImage(category?: string | null): string | undefined {
  if (!category) return undefined
  return CATEGORY_IMAGES[category]
}
